import { ConnectionHandler } from "relay-runtime"

export const episodeOfCareProgressNotesConnectionKey = "EpisodeOfCareProgressNotesConnection_progressNotes"

export const getEpisodeOfCareProgressNotesConnectionId = (episodeOfCareId: string) => {
  return ConnectionHandler.getConnectionID(episodeOfCareId, episodeOfCareProgressNotesConnectionKey)
}
